import React from 'react';
import { shuffleText } from '../Utility';

export default class Shuffler extends React.Component {
    constructor(props) {
        super(props);

        this.state = { value: shuffleText(this.props.length).join('') };
    }

    componentDidMount = () => {
        var shuffle = () => {
            setTimeout(() => {
                this.setState({ value: shuffleText(this.props.length).join('') });
                shuffle();
            }, 75);
        }
        shuffle();
    }

    render() {
        return this.state.value;
    }
}